@if (isRouterLink) {
    <a [routerLink]="link" [queryParams]="queryParams" [attr.aria-label]="ariaLabel">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
} @else {
    <a [href]="externalLink" [attr.aria-label]="ariaLabel">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
}

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
